import {
  Box,
  VStack,
  HStack,
  Icon,
  Button,
  Text,
  Grid,
  Flex,
  Image,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { RiArrowDropLeftLine, RiArrowDropRightLine } from "react-icons/ri";
import ExamQuestions from "./exam-questions";
import ExamSolvedQuestions from "./exam-solved-questions";
import ExamEllipses from "./exam-ellipses";

const DailyChallengeContent = ({
  questions,
  answers = [],
  setAnswers,
  selectedQuestionIdx,
  setSelectedQuestionIdx,
  correctionArr = [],
  showCorrection = false,
}) => {
  const currentQuestion = questions[selectedQuestionIdx];

  const handelNextQuestion = () => {
    if (selectedQuestionIdx >= questions?.length - 1) {
      setSelectedQuestionIdx(0);
    } else {
      setSelectedQuestionIdx((s) => s + 1);
    }
  };

  const handelPrevQuestion = () => {
    if (selectedQuestionIdx <= 0) {
      setSelectedQuestionIdx(questions?.length - 1);
    } else {
      setSelectedQuestionIdx((s) => s - 1);
    }
  };

  if (!currentQuestion) return null;

  return (
    <VStack spacing={4} align="stretch" w="100%">
      {/* Question Navigation */}
      <HStack justify="center" spacing={2}>
        <Icon
          as={RiArrowDropLeftLine}
          onClick={handelPrevQuestion}
          fontSize="30px"
          cursor="pointer"
          color="orange.500"
          _hover={{ color: "orange.600" }}
        />
        <ExamEllipses
          answeredQ={Object.keys(answers)}
          questionsCount={questions?.length}
          setSelectedQuestionIdx={setSelectedQuestionIdx}
          selectedQuestionIdx={selectedQuestionIdx}
        />
        <Icon
          as={RiArrowDropRightLine}
          onClick={handelNextQuestion}
          fontSize="30px"
          cursor="pointer"
          color="orange.500"
          _hover={{ color: "orange.600" }}
        />
      </HStack>

      {/* Question Content */}
      {showCorrection ? (
        <ExamSolvedQuestions
          data={currentQuestion}
          correctionArr={correctionArr}
          selectedQuestionIdx={selectedQuestionIdx}
        />
      ) : (
        <ExamQuestions
          data={currentQuestion}
          answers={answers}
          setAnswers={setAnswers}
          selectedQuestionIdx={selectedQuestionIdx}
        />
      )}

      {/* Navigation Buttons */}
      <HStack justify="space-between">
        <Button
          onClick={handelPrevQuestion}
          size="sm"
          variant="outline"
          colorScheme="orange"
        >
          Previous
        </Button>
        <Text fontSize="sm" color="gray.600">
          Question {selectedQuestionIdx + 1} of {questions?.length}
        </Text>
        <Button
          onClick={handelNextQuestion}
          size="sm"
          variant="outline"
          colorScheme="orange"
        >
          Next
        </Button>
      </HStack>
    </VStack>
  );
};

export default DailyChallengeContent;

